// extracted by mini-css-extract-plugin
module.exports = {"button_box":"BonusReportsDownloadModal__button_box--22oQq","button_frame":"BonusReportsDownloadModal__button_frame--2rWdX"};